module.exports = __webpack_public_path__ + "img/image-upload.6c6fa9e2.svg";